import React from 'react';
import Section from '../myaccountsection';
import translate from '../../../../utils/translate';
import headerActions from '../../../../actions/header';
import get from 'lodash/get';

export default class HeaderMyAccount extends React.Component {
  static propTypes = {
    loggedUser: React.PropTypes.object,
    links:      React.PropTypes.object,
    myAccount:  React.PropTypes.object
  };

  getLoginLink = () => {
    return (
      <a className="header__panel__title--large_link"
        href="/myAccount/loginRegister.php#login"
        data-component="header-login-link"
        onClick={
          () => location.hash !== '#login' && location.reload()
        }
      >
        {translate('topLinksModule', 'HEADER_LOGIN_BUTTON')}
      </a>
    );
  };

  getUserName = () => {
    var username = get(this.props, 'loggedUser.firstname', '')
    .replace(/\+/g, ' ') + ' ' + get(this.props, 'loggedUser.lastname', '').replace(/\+/g, ' ');

    if (!get(this.props, 'loggedUser.firstname')) {
      return this.getLoginLink();
    }
    else {
      return username;
    }

  };

  getWelcomeMessage = () => {
    if (!get(this.props, 'loggedUser.firstname')) {
      return this.getLoginLink();
    }
    else {
      return translate('topLinksModule', 'WELCOME', {
        '%FIRSTNAME%': get(this.props, 'loggedUser.firstname', '').replace(/\+/g, ' '),
        '%LASTNAME%':  get(this.props, 'loggedUser.lastname', '').replace(/\+/g, ' ')
      });
    }
  };

  logout = () => {
    headerActions.logout(this.props.links.logout);
  };

  goToLogin = () => {
    window.location.href = '/myAccount/';
  };

  render () {
    return (
      <div className="header__panel--mobile">
        <header className="header__panel__header">
          <h3 className="header__panel__title--large">
            {this.props.loggedUser && translate('myAccountModule', 'MY_ACCOUNT') + ': '}
            <span data-hj-suppress>{this.getUserName()}</span>
          </h3>
          <h3 className="header__panel__title--mobile" data-hj-suppress>{this.getWelcomeMessage()}</h3>
        </header>

        <div className="header__panel__content">
          <Section type="upcomingEvents" myAccount={this.props.myAccount} />
          <Section type="pastEvents" myAccount={this.props.myAccount} />
          <Section type="profile" myAccount={this.props.myAccount} />
          <Section type="address" myAccount={this.props.myAccount} />
          <Section type="newsletter" myAccount={this.props.myAccount} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/account/myaccount/index.js